import { ModalProps } from 'antd';
import DpModalBase from './DpModalBase';
import styled from 'styled-components';

function DpModalWithGradientButton(props: ModalProps) {
  return <DpModalBase {...props}>{props.children}</DpModalBase>;
}

export default styled(DpModalWithGradientButton)`
  .next-antd-modal-body {
    font-size: 16px;
    color: #0c0c0c;
    opacity: 0.6;
  }

  .next-antd-modal-footer {
    .next-antd-btn {
      &-primary:not(:disabled):not(.next-antd-btn-disabled) {
        background: linear-gradient(180deg, #725cff 0%, rgba(141, 131, 255, 0.8) 100%);
        border-bottom-color: #b3b2ff;

        &:hover,
        &:focus {
          background: linear-gradient(180deg, #725cff 0%, rgba(141, 131, 255, 0.8) 100%);
          border-bottom-color: #b3b2ff;
        }

        &:active {
          background: linear-gradient(180deg, #725cff 0%, rgba(141, 131, 255, 0.8) 100%);
          border-bottom-color: #b3b2ff;
        }
      }
    }
  }
`;
